import { Role } from "elephant-web/gql";

export const ALLOWED_INVENTORY_REQUEST_ROLES = [
  Role.Nurse,
  Role.Doctor,
  Role.Pharmacist,
  Role.Dispenser,
  Role.Clinic,
  Role.CashOfficer,
  Role.Technician,
];

export function hasMakeInventoryRequestPermission(role: string): boolean {
  return ALLOWED_INVENTORY_REQUEST_ROLES.includes(role as Role);
}

export const ALLOWED_UPDATE_LOT_ROLES = [
  Role.Pharmacist,
  Role.Elephant,
  Role.Clinic,
  Role.Doctor,
  Role.Nurse,
];

export function hasUpdateLotPermissions(roleName: string) {
  return ALLOWED_UPDATE_LOT_ROLES.includes(roleName as Role);
}

// Only Pharmacists can start and run a stocktake, so the ongoing/review pages
// are gated to the same role as the "Start Stocktake" action that creates them.
export const ALLOWED_STOCKTAKE_ROLES = [Role.Pharmacist];

export function hasStockTakePermission(roleName: string) {
  return ALLOWED_STOCKTAKE_ROLES.includes(roleName as Role);
}

export const ALLOWED_STOCKTAKE_HISTORY_ROLES = [
  Role.Pharmacist,
  Role.Dispenser,
];

export function hasStockTakeHistoryPermission(roleName: string) {
  return ALLOWED_STOCKTAKE_HISTORY_ROLES.includes(roleName as Role);
}
